import React from 'react';
import { Typography } from 'antd';
import {
  PRIMITIVE_AUTHORITY_FLAGS,
  type PrimitivePresentationState,
} from './primitiveSurfaceState';
import { PrimitiveSurfaceFrame } from './PrimitiveSurfaceFrame';
import styles from './primitives.module.css';

const { Text } = Typography;

export interface ContextBarProps {
  readonly presentationState: PrimitivePresentationState;
  readonly tenantLabel?: string | null;
  readonly areaLabel?: string | null;
  readonly objectLabel?: string | null;
  readonly modeLabel?: string | null;
  readonly grantsAuthority?: false;
  readonly grantsApproval?: false;
  readonly 'data-testid'?: string;
}

export function ContextBar(props: ContextBarProps): React.ReactElement {
  const grantsAuthority = props.grantsAuthority ?? PRIMITIVE_AUTHORITY_FLAGS.grantsAuthority;
  const grantsApproval = props.grantsApproval ?? PRIMITIVE_AUTHORITY_FLAGS.grantsApproval;
  if (grantsAuthority !== false || grantsApproval !== false) {
    throw new Error('ContextBar must keep grantsAuthority/grantsApproval=false');
  }

  return (
    <PrimitiveSurfaceFrame
      title="컨텍스트"
      presentationState={props.presentationState}
      emptyMessage="객체 컨텍스트가 없습니다."
      data-testid={props['data-testid'] ?? 'context-bar'}
      aria-label="컨텍스트"
    >
      <div className={styles.primitiveStack}>
        <div className={styles.primitiveFieldRow}>
          <span className={styles.primitiveFieldLabel}>테넌트</span>
          <Text>{props.tenantLabel?.trim() ? props.tenantLabel : '—'}</Text>
        </div>
        <div className={styles.primitiveFieldRow}>
          <span className={styles.primitiveFieldLabel}>영역</span>
          <Text>{props.areaLabel?.trim() ? props.areaLabel : '—'}</Text>
        </div>
        <div className={styles.primitiveFieldRow}>
          <span className={styles.primitiveFieldLabel}>객체</span>
          <Text>{props.objectLabel?.trim() ? props.objectLabel : '—'}</Text>
        </div>
        <div className={styles.primitiveFieldRow}>
          <span className={styles.primitiveFieldLabel}>모드</span>
          <Text>{props.modeLabel?.trim() ? props.modeLabel : '—'}</Text>
        </div>
      </div>
    </PrimitiveSurfaceFrame>
  );
}
